/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentStatusComparison } from "./ShipmentStatusComparison";
import {
  ShipmentStatusComparisonFromJSON,
  ShipmentStatusComparisonFromJSONTyped,
  ShipmentStatusComparisonToJSON,
  ShipmentStatusComparisonToJSONTyped,
} from "./ShipmentStatusComparison";

/**
 *
 * @export
 * @interface NetSuiteShipmentStatusReport
 */
export interface NetSuiteShipmentStatusReport {
  /**
   *
   * @type {string}
   * @memberof NetSuiteShipmentStatusReport
   */
  checkedAt: string;
  /**
   *
   * @type {boolean}
   * @memberof NetSuiteShipmentStatusReport
   */
  truncated: boolean;
  /**
   *
   * @type {string}
   * @memberof NetSuiteShipmentStatusReport
   */
  rawResponse: string;
  /**
   *
   * @type {Array<ShipmentStatusComparison>}
   * @memberof NetSuiteShipmentStatusReport
   */
  comparisons: Array<ShipmentStatusComparison>;
}

/**
 * Check if a given object implements the NetSuiteShipmentStatusReport interface.
 */
export function instanceOfNetSuiteShipmentStatusReport(
  value: object,
): value is NetSuiteShipmentStatusReport {
  if (!("checkedAt" in value) || value["checkedAt"] === undefined) return false;
  if (!("truncated" in value) || value["truncated"] === undefined) return false;
  if (!("rawResponse" in value) || value["rawResponse"] === undefined)
    return false;
  if (!("comparisons" in value) || value["comparisons"] === undefined)
    return false;
  return true;
}

export function NetSuiteShipmentStatusReportFromJSON(
  json: any,
): NetSuiteShipmentStatusReport {
  return NetSuiteShipmentStatusReportFromJSONTyped(json, false);
}

export function NetSuiteShipmentStatusReportFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NetSuiteShipmentStatusReport {
  if (json == null) {
    return json;
  }
  return {
    checkedAt: json["checkedAt"],
    truncated: json["truncated"],
    rawResponse: json["rawResponse"],
    comparisons: (json["comparisons"] as Array<any>).map(
      ShipmentStatusComparisonFromJSON,
    ),
  };
}

export function NetSuiteShipmentStatusReportToJSON(
  json: any,
): NetSuiteShipmentStatusReport {
  return NetSuiteShipmentStatusReportToJSONTyped(json, false);
}

export function NetSuiteShipmentStatusReportToJSONTyped(
  value?: NetSuiteShipmentStatusReport | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    checkedAt: value["checkedAt"],
    truncated: value["truncated"],
    rawResponse: value["rawResponse"],
    comparisons: (value["comparisons"] as Array<any>).map(
      ShipmentStatusComparisonToJSON,
    ),
  };
}
